import { defineAction } from '~/prix'
import { z } from 'zod'
import collectedAnimalUpdateAction from './collectedAnimalUpdate.action.json' with { type: 'json' }
import { collectedAnimalObject } from '../collectedAnimalObject'

const collectedAnimalUpdateDefinition = defineAction({
  ...collectedAnimalUpdateAction,

  input: collectedAnimalObject
    .pick({
      id: true,
      species: true,
      weight: true,
      unitValue: true,
      discountValue: true,
      earringNumber: true,
    })
    .partial()
    .required({ id: true }),
  output: z.object({}),
})

export default collectedAnimalUpdateDefinition
